import { render, staticRenderFns } from "./FullScreenToolbar.vue?vue&type=template&id=b2d18898"
import script from "./FullScreenToolbar.vue?vue&type=script&lang=js"
export * from "./FullScreenToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports